// Lib
import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';

// Plugins
import { LifecyclePlugin } from '../../../capacitor_plugins/lifecycle';

// Constants
import { CAPACITOR_LIFECYCLE_PLUGIN } from '../../../capacitor_plugins/pluginConstants';

const useAttachCapacitorLifecycle = () => {
    useEffect(() => {
        if (Capacitor.isPluginAvailable(CAPACITOR_LIFECYCLE_PLUGIN)) {
            LifecyclePlugin.webDidLoad();
        }
    }, []);
};

export default useAttachCapacitorLifecycle;
